var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExceptionalVolumeDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "30px",
    viewBox: "0 0 34 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Global / Icons / Notifications / Exceptional Volume Down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Global-/-Icons-/-Notifications-/-Exceptional-Volume-Down",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#383D41",
    x: 0,
    y: 0,
    width: 34,
    height: 30,
    rx: 7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "arrow_right-[#292]",
    fill: "#FFFFFF",
    transform: "translate(17.000000, 15.000000) scale(-1, 1) translate(-17.000000, -15.000000) ",
    points: "19 22.5 19 20.5 23.653 20.5 17.354 14.202 14.821 16.735 7 8.914 8.414 7.5 14.821 13.907 15.94 12.787 15.937 12.784 17.351 11.37 25 19.019 25 14.5 27 14.5 27 22.5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExceptionalVolumeDown);
export default __webpack_public_path__ + "static/media/exceptional-volume-down.b52b841c.svg";
export { ForwardRef as ReactComponent };